import React from "react";
import { ChevronLeft, ChevronRight, Pause, Play } from "lucide-react";
import { useSiteContent } from "../admin/SiteContentContext";

export default function CareSlider() {
  const { content } = useSiteContent();
  const { careSlides } = content;
  const [i, setI] = React.useState(0);
  const [playing, setPlaying] = React.useState(true);
  const total = careSlides.length;

  React.useEffect(() => {
    if (!playing) return;
    const t = setInterval(() => setI(v => (v + 1) % total), 5500);
    return () => clearInterval(t);
  }, [playing, total]);

  const slide = careSlides[i];
  const pad = (n) => String(n).padStart(2, "0");

  return (
    <section className="relative py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-5 gap-10 items-center">
        <div className="lg:col-span-2">
          <span className="kicker"><span className="w-1.5 h-1.5 rounded-full bg-[#c7e34a] pulse-dot" /> Wellbeing starts with listening</span>
          <h3 className="font-serif-display text-4xl md:text-5xl text-white mt-4 mb-6">Health is personal.</h3>

          <div className="flex items-baseline gap-3 mb-6">
            <span className="font-serif-display text-5xl text-white">{pad(i+1)}</span>
            <span className="text-slate-400">/ {pad(total)}</span>
          </div>

          <p className="text-slate-300 leading-relaxed max-w-md">{slide.caption}</p>

          <p className="text-xs tracking-widest uppercase text-slate-500 mt-8">General wellbeing reflections · up to 1,000 slides supported</p>

          <div className="flex items-center gap-3 mt-6">
            <button onClick={() => setI((i-1+total)%total)} aria-label="prev"
              className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 transition">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button onClick={() => setI((i+1)%total)} aria-label="next"
              className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 transition">
              <ChevronRight className="w-5 h-5" />
            </button>
            <button onClick={() => setPlaying(p => !p)} aria-label="play/pause"
              className="w-11 h-11 rounded-full bg-[#c7e34a] text-[#0b1220] flex items-center justify-center hover:brightness-105 transition">
              {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5" />}
            </button>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-[#101830]">
            <div className="aspect-[16/10] relative">
              <img key={slide.image} src={slide.image} alt={slide.kicker}
                className="w-full h-full object-cover fade-up" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070b17] via-[#070b17]/40 to-transparent" />
              <div className="absolute left-6 top-6">
                <span className="badge-pill">{slide.kicker}</span>
              </div>
              <div className="absolute left-6 right-6 bottom-6">
                <p className="font-serif-display text-white text-xl md:text-2xl leading-snug">“{slide.quote}”</p>
                <p className="text-sm text-slate-300 mt-2">— Dazile Auguste</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
